import {Component, ElementRef, inject} from '@angular/core';
import { AppMenu } from './app.menu';
import {LayoutService} from "../service/app.layout.service";

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu],
    template: ` <div class="layout-sidebar">
        <app-menu></app-menu>
    </div>`
})
export class AppSidebar {
    constructor() {}

    layoutService = inject(LayoutService);
    el = inject(ElementRef);
}
